<template>
  <div>
    <GridVx
      ref="AlignedGridsService"
      :auto-size-cell="true"
      :columns="columnDefs"
      :rows="recordRowsData"
      class="agGrid"
      dom-layout="scroll"
      style="height: 300px"
    />
  </div>
</template>
<script>
export default {
  props: {
    recordRows: []
  },
  data() {
    return {
      rows: [],
      columnDefs: [
        {
          headerName: 'Mã',
          minWidth: 100,
          field: 'room_surcharge_code',
          cellStyle: params => {
            // if(params.value === 0) return {}
          }
        },
        {
          headerName: 'Mô tả',
          minWidth: 100,
          field: 'desc'
        },
        {
          headerName: 'Giá đơn vị',
          minWidth: 100,
          field: 'price',
          valueFormatter(params) {
            return params.value === null
              ? ''
              : Intl.NumberFormat().format(params.value)
          }
        },
        {
          headerName: 'Số lượng',
          minWidth: 100,
          field: 'quantity'
        },
        {
          headerName: 'Từ ngày',
          minWidth: 100,
          field: 'start_date',
          valueFormatter: params => {
            return this.$moment(params.value).format('DD-MM-Y')
          }
        },
        {
          headerName: 'Đến ngày',
          minWidth: 100,
          field: 'end_date',
          valueFormatter: params => {
            return this.$moment(params.value).format('DD-MM-Y')
          }
        },
        {
          headerName: 'Số đêm',
          minWidth: 100,
          field: 'total_price',
          valueGetter: params => {
            const totalDate = this.$moment(params.data.end_date).diff(
              params.data.start_date,
              'days'
            )
            return totalDate
          }
        },
        {
          headerName: 'Thành tiền',
          minWidth: 100,
          field: 'total_price',
          valueGetter: params => {
            const totalDate = this.$moment(params.data.end_date).diff(
              params.data.start_date,
              'days'
            )
            return (
              params.data.quantity * params.data.price * Math.max(totalDate, 1)
            )
          },
          valueFormatter(params) {
            return params.value === null
              ? ''
              : Intl.NumberFormat().format(params.value)
          }
        },
        {
          headerName: 'Ghi chú',
          field: 'note'
        }
      ]
    }
  },
  computed: {
    recordRowsData() {
      // Force reactivity when prop changes
      return this.recordRows || []
    }
  },
  watch: {
    recordRows: {
      handler(newVal) {
        // GridVx component sẽ tự động cập nhật khi prop rows thay đổi
        // Nhưng để chắc chắn, ta force refresh grid nếu có gridApi
        this.$nextTick(() => {
          if (this.$refs.AlignedGridsService && this.$refs.AlignedGridsService.gridApi) {
            this.$refs.AlignedGridsService.gridApi.refreshCells({ force: true })
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // Initialize grid with data
    this.$nextTick(() => {
      if (this.$refs.AlignedGridsService && this.$refs.AlignedGridsService.gridOptions) {
        this.$refs.AlignedGridsService.gridOptions.api.setRowData(this.recordRows || [])
      }
    })
  }
}
</script>
